import React, { useState, useEffect, useRef } from "react";

import { string, bool } from "prop-types";

import Modal from "../../Modal/Modal.jsx";
import Icon from "../../Icon/Icon.jsx";
import ImageBlock from "../../ImageBlock/ImageBlock.jsx";
import BackgroundVideo from "../../BackgroundVideo/BackgroundVideo.jsx";
import initBackgroundVideo from "../../BackgroundVideo/initBackgroundVideo.js";

import cx from "classnames";

const propTypes = {
  href: string.isRequired,
  text: string.isRequired,
  poster: string,
  editing: bool,
};

const FrameworkModal = (props) => {
  const { href, text, poster, editing } = props;

  const [modalOpen, setModalOpen] = useState(false);

  const videoRef = useRef();

  const videoTypes = /(\.|\/)(mov|mp4)$/i;
  const contentIsVideo = videoTypes.test(href);

  useEffect(() => {
    if (videoRef.current) {
      initBackgroundVideo(".framework-video-wrapper");
    }
  }, [videoRef.current]);

  const openModal = (e) => {
    e.preventDefault();

    if (editing) {
      return;
    }

    setModalOpen(true);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setModalOpen(false);
  };

  return (
    <div>
      <button
        className="arrow-link arrow-link--external framework-modal__trigger"
        onClick={openModal}
      >
        <span>{text}</span>
        <Icon iconName="external" />
      </button>
      <Modal
        className={cx("modal--framework")}
        isOpen={modalOpen}
        title={false}
        onClose={handleClose}
        showPrintButton={!contentIsVideo}
      >
        <div className="framework-chart">
          {contentIsVideo ? (
            <div ref={videoRef} className="framework-video-wrapper">
              <BackgroundVideo
                src={href}
                poster={poster}
                autoplay={false}
                hasAudio="True"
              />
            </div>
          ) : (
            <ImageBlock
              image={{
                srcSet: href,
                sizes: "(min-width: 1570) 1570px, 80vw",
                height: null,
                width: null,
              }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

FrameworkModal.propTypes = propTypes;

export default FrameworkModal;
